import { IconWithText } from 'common/icon/icon-with-text.js';
import { IconNameV1, IconV1 } from 'common/icon/iconV1.js';
import { ComponentFakeLink } from 'common/link/link-component-fake.js';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'redux-state/configure-store.js';
import { REDUX_WEATHER_WARNINGS_FETCH_INIT } from 'redux-state/weather-warnings/reducer.js';
import { ILocationWarningType } from 'redux-state/weather-warnings/types.js';
import { findHighestRankedHighSeasIcon } from 'utilities/weather-warnings/highestRankedHighSeasIcon.js';
import { getLoadedLocationWarnings } from 'utilities/weather-warnings/warnings.js';

interface HighSeasListItemProps {
  label: string;
  onClick: () => void;
  location: ILocationWarningType;
}

export const HighSeasListItem = ({ label, onClick, location }: HighSeasListItemProps) => {
  const appDispatch = useAppDispatch();
  const weatherWarnings = useAppSelector((state) => state.WEATHER_WARNINGS);
  const [highestRankedWarningIcon, setHighestRankedHighSeasIcon] = useState<IconNameV1>();

  useEffect(() => {
    const warningState = getLoadedLocationWarnings(
      { type: location.type, key: location.key },
      weatherWarnings.warnings,
    );
    const warnings = warningState?.warnings ?? [];
    const highestRankedHighSeason = findHighestRankedHighSeasIcon(warnings);
    setHighestRankedHighSeasIcon(highestRankedHighSeason);

    // const prop = lookupWeatherTypeKey({ type, key });
  }, [weatherWarnings, location]);

  useEffect(() => {
    appDispatch(REDUX_WEATHER_WARNINGS_FETCH_INIT({ warningProps: location, timestamp: Date.now() }));
  }, [location, appDispatch]);

  const renderedLabel = <p className="u-mT-xs u-mB-xs">{label}</p>;
  // const highestRankedWarningIcon = findHighestRankedHighSeasIcon(locWarnings);

  return (
    <li data-module="LocationList-item-high-seas" className="LocationList-item">
      <ComponentFakeLink onClickCB={onClick} classes="LocationList-item-link">
        <>
          {highestRankedWarningIcon ? (
            <IconWithText icon={highestRankedWarningIcon} classes="IconWithText--vCenter">
              {renderedLabel}
            </IconWithText>
          ) : (
            renderedLabel
          )}
          <span className="LocationList-item-link-actions">
            {/* Chevron - always present */}
            <IconV1 icon="chevron-right" iconClass="svg--1em" />
          </span>
        </>
      </ComponentFakeLink>
    </li>
  );
};
